import { Currency } from '../../constants/currency';
import type { Condition } from '../../hooks/useProductData';
import type { IDebitCardOffer } from '../../interfaces/offers';
import { getAmountString } from '../humanization';

export const getDebitCardConditions = (item: IDebitCardOffer): Condition[] => {
  const { sortCashbackMin, sortCashback, maintenancePrice } = item;

  const cashbackValue =
    sortCashback && (sortCashbackMin ? `${sortCashbackMin} - ${sortCashback}` : String(sortCashback).replace('.', ','));
  const cost = maintenancePrice ? `${getAmountString(maintenancePrice, Currency.RUB)} в год` : 'Бесплатно';

  return [
    { value: cashbackValue ? `${cashbackValue}%` : 'Отсутствует', description: 'Кэшбэк' },
    { value: cost, description: 'Обслуживание' },
  ];
};
